import type { ProductMetadataFeature } from '../entities/ProductMetadata';
import { ProductMetadataBuilder } from './ProductMetadataBuilder';

export class UnlimitedProductMetadataBuilder extends ProductMetadataBuilder {
  getVirtualFeatures(): ProductMetadataFeature[] {
    return ['list_management', 'chrome_extension'];
  }

  getIsMostPopular(): boolean {
    return true;
  }
}
